// extracted by mini-css-extract-plugin
export var colorSquare = "_s2-0";
export var danger = "_s2-5";
export var lightPink = "_s2-8";
export var neutralBlue = "_s2-7";
export var neutralYellow = "_s2-6";
export var normal = "_s2-1";
export var primary = "_s2-2";
export var primaryLight = "_s2-3";
export var solidBlack = "_s2-g";
export var solidGreen = "_s2-b";
export var solidLightBlue = "_s2-d";
export var solidNavy = "_s2-c";
export var solidOrange = "_s2-f";
export var solidPink = "_s2-e";
export var solidRed = "_s2-9";
export var solidYellow = "_s2-a";
export var success = "_s2-4";